import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { BillingPeriod, BillingPeriodParams } from './types';

export const GET_BILLING_PERIOD_LIST = 'billingPeriods/GET_BILLING_PERIOD_LIST';
export const GET_BILLING_PERIOD_LIST_SUCCESS =
  'billingPeriods/GET_BILLING_PERIOD_LIST_SUCCESS';
export const GET_BILLING_PERIOD_LIST_ERROR =
  'billingPeriods/GET_BILLING_PERIOD_LIST_ERROR';

export const CREATE_BILLING_PERIOD = 'billingPeriods/CREATE_BILLING_PERIOD';
export const CREATE_BILLING_PERIOD_SUCCESS =
  'billingPeriods/CREATE_BILLING_PERIOD_SUCCESS';
export const CREATE_BILLING_PERIOD_ERROR =
  'billingPeriods/CREATE_BILLING_PERIOD_ERROR';

export const UPDATE_BILLING_PERIOD = 'billingPeriods/UPDATE_BILLING_PERIOD';
export const UPDATE_BILLING_PERIOD_SUCCESS =
  'billingPeriods/UPDATE_BILLING_PERIOD_SUCCESS';
export const UPDATE_BILLING_PERIOD_ERROR =
  'billingPeriods/UPDATE_BILLING_PERIOD_ERROR';

export const DELETE_BILLING_PERIOD = 'billingPeriods/DELETE_BILLING_PERIOD';
export const DELETE_BILLING_PERIOD_SUCCESS =
  'billingPeriods/DELETE_BILLING_PERIOD_SUCCESS';
export const DELETE_BILLING_PERIOD_ERROR =
  'billingPeriods/DELETE_BILLING_PERIOD_ERROR';

export const getBillingPeriodListAsync = createAsyncAction(
  GET_BILLING_PERIOD_LIST,
  GET_BILLING_PERIOD_LIST_SUCCESS,
  GET_BILLING_PERIOD_LIST_ERROR,
)<BillingPeriodParams, BillingPeriod[], AxiosError>();

export const createBillingPeriodAsync = createAsyncAction(
  CREATE_BILLING_PERIOD,
  CREATE_BILLING_PERIOD_SUCCESS,
  CREATE_BILLING_PERIOD_ERROR,
)<BillingPeriodParams, BillingPeriod[], AxiosError>();

export const updateBillingPeriodAsync = createAsyncAction(
  UPDATE_BILLING_PERIOD,
  UPDATE_BILLING_PERIOD_SUCCESS,
  UPDATE_BILLING_PERIOD_ERROR,
)<BillingPeriodParams, BillingPeriod, AxiosError>();

export const deleteBillingPeriodAsync = createAsyncAction(
  DELETE_BILLING_PERIOD,
  DELETE_BILLING_PERIOD_SUCCESS,
  DELETE_BILLING_PERIOD_ERROR,
)<BillingPeriodParams, number, AxiosError>();
